import { FontLoader } from 'qunar-react-native';
import fontSet from './FontSets.json';
import Icon from './components/Icon';
//加载字体
FontLoader.loadFontSet(fontSet);
import * as font from './font';
import { space } from './space';
import * as responsive from './responsive';
import * as Colors from './colors';
import * as layout from './layout';
import * as border from './border';
import * as shape from './shape';
const theme = {
    color: Colors,
    font,
    space,
    responsive,
    layout,
    border,
    shape,
    FONT_FAMILY: Object.keys(fontSet)[0]
};
function useTheme(args = {}) {
    Object.assign(theme, args);
    return theme;
}
// 设置Icon的字体
Icon.fontFamily = theme.FONT_FAMILY;
const ThemeColor = Colors.scenes.baseColor;
export default theme;
export { useTheme, Colors, Icon, ThemeColor };
export * from './interface';
